import { render, staticRenderFns } from "./ArticleListingNominativ.vue?vue&type=template&id=4f76c880"
import script from "./ArticleListingNominativ.vue?vue&type=script&lang=js"
export * from "./ArticleListingNominativ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports